import type { MatrixClient } from 'matrix-js-sdk'
import type { BridgeType } from '../store/room-store'
import { getBridgeBotRoom } from './dm'

export interface BridgeNetwork {
  type: NonNullable<BridgeType>
  label: string
  /** Hint shown in the identifier input. */
  placeholder: string
  /** Builds the management-room command that opens a chat with `identifier`. */
  command: (identifier: string) => string
}

// mautrix bridge commands. Sent to the network's management room; the bridge
// then creates the portal room, which shows up in the room list.
const NETWORKS: BridgeNetwork[] = [
  {
    type: 'whatsapp',
    label: 'WhatsApp',
    placeholder: '+1 555 123 4567',
    command: (id) => `start-chat ${id}`,
  },
  {
    type: 'telegram',
    label: 'Telegram',
    placeholder: '@username or phone',
    command: (id) => `pm ${id}`,
  },
  {
    type: 'signal',
    label: 'Signal',
    placeholder: '+1 555 123 4567',
    // mautrix-signal (megabridge) uses `start-chat`, matching WhatsApp. Legacy
    // builds used `pm` — swap if the bot rejects it.
    command: (id) => `start-chat ${id}`,
  },
]

/** Networks whose bridge is actually connected (a management room exists). */
export function availableBridges(client: MatrixClient): BridgeNetwork[] {
  return NETWORKS.filter((n) => getBridgeBotRoom(client, n.type) !== null)
}

/**
 * Ask a bridge to open a chat with the given identifier by sending its command
 * to the management room. Returns that room's ID so the caller can navigate
 * there and watch the bridge create the portal.
 */
export async function startBridgedChat(
  client: MatrixClient,
  network: BridgeNetwork,
  identifier: string,
): Promise<string> {
  const roomId = getBridgeBotRoom(client, network.type)
  if (!roomId) throw new Error(`${network.label} bridge is not connected`)
  await client.sendTextMessage(roomId, network.command(identifier.trim()))
  return roomId
}
